<!-- Category periods -->
@if (data && (!data.isChild || (data.isChild && data.subCategory))) {
  <div [attr.auto-qa]="autoTestAttribute">
    <!-- Period if driver=site -->
    @if (data.driver === 'DRIVER_SITE') {
      <aux-forecast-table-grid-period-site
        [placeholder]="componentParent.checkService.formControlConstants.PLACEHOLDER.SELECT"
        [isChild]="false"
        [onMethodChange]="componentParent.onMethodChange"
        [categoryId]="data.id"
        [primarySettingsId]="data.primarySettingsId"
        [disabled]="
          !data.primarySettingsOverride ||
          disablePeriod ||
          componentParent.isForecastFinalized ||
          componentParent.isClosedMonthsProcessing ||
          !componentParent.isSiteDriverAvailable
        "
        [tooltip]="
          componentParent.checkService.tooltipText(
            componentParent.isForecastFinalized || componentParent.isClosedMonthsProcessing,
            componentParent.userHasModifyPermissions
          )
        "
        [isInvalid]="
          (componentParent.checkService.isShowError(data.primarySettingsId) | async) ||
          (componentParent.checkService.isCategoryUnforecasted(data.primarySettingsId) | async) ||
          false
        "
        [siteCurves]="componentParent.siteCurves"
        [periodSiteOptions]="componentParent.periodService.PeriodSiteOptions"
        [driverSettingId]="data.driverSettingId"
      />
    }

    <!-- Period if driver=patient -->
    @if (data.driver === 'DRIVER_PATIENT') {
      <aux-forecast-table-grid-period-patient
        [tooltip]="
          componentParent.checkService.tooltipText(
            componentParent.isForecastFinalized || componentParent.isClosedMonthsProcessing,
            componentParent.userHasModifyPermissions
          )
        "
        [periodPatientOptions]="componentParent.periodService.PeriodPatientOptions"
        [selectedPeriodPatientOption]="'Patient Curve'"
      />
    }

    <!-- Period if driver=time (category) -->
    @if (data.driver === 'DRIVER_TIME') {
      <aux-forecast-table-grid-period-time
        [placeholder]="componentParent.checkService.formControlConstants.PLACEHOLDER.SELECT"
        [isChild]="false"
        [onPeriodChange]="componentParent.onPeriodChange"
        [categoryId]="data.id"
        [primarySettingsId]="data.primarySettingsId"
        [disabled]="
          !data.primarySettingsOverride ||
          disablePeriod ||
          componentParent.isForecastFinalized ||
          componentParent.isClosedMonthsProcessing
        "
        [tooltip]="
          componentParent.checkService.tooltipText(
            componentParent.isForecastFinalized || componentParent.isClosedMonthsProcessing,
            componentParent.userHasModifyPermissions
          )
        "
        [isInvalid]="
          (componentParent.checkService.isShowError(data.primarySettingsId) | async) ||
          (componentParent.checkService.isCategoryUnforecasted(data.primarySettingsId) | async) ||
          false
        "
        [fullSettings]="data.fullCategory!.primary_settings"
        [timelinePhases]="componentParent.timelinePhases"
        [PeriodService]="componentParent.periodService"
      />
    }

    <!-- Period if driver=custom curve -->
    @if (data.driver === 'DRIVER_CUSTOM') {
      <aux-forecast-table-grid-period-custom-curve
        [tooltip]="
          componentParent.checkService.tooltipText(
            componentParent.isForecastFinalized || componentParent.isClosedMonthsProcessing,
            componentParent.userHasModifyPermissions
          )
        "
      />
    }
  </div>
}

<!-- Activity periods -->
@if (data && data.isChild && !data.subCategory) {
  <div>
    <!-- Period if driver=site -->
    @if (data.driver === 'DRIVER_SITE') {
      <aux-forecast-table-grid-period-site
        [placeholder]="componentParent.checkService.formControlConstants.PLACEHOLDER.SELECT"
        [isChild]="true"
        [onMethodChange]="componentParent.onMethodChange"
        [categoryId]="data.id"
        [primarySettingsId]="data.primarySettingsId"
        [disabled]="
          (data.parentCategory?.primarySettingsOverride && !data.primarySettingsOverride) ||
          componentParent.isForecastFinalized ||
          componentParent.isClosedMonthsProcessing ||
          disablePeriod ||
          !componentParent.isSiteDriverAvailable
        "
        [tooltip]="
          componentParent.checkService.tooltipText(
            componentParent.isForecastFinalized || componentParent.isClosedMonthsProcessing,
            componentParent.userHasModifyPermissions
          )
        "
        [isInvalid]="
          (componentParent.checkService.isShowError(data.primarySettingsId) | async) ||
          (componentParent.checkService.isActivityUnforecasted(data.id) | async) ||
          false
        "
        [siteCurves]="componentParent.siteCurves"
        [periodSiteOptions]="componentParent.periodService.PeriodSiteOptions"
        [driverSettingId]="data.driverSettingId"
      />
    }

    <!-- Period if driver=patient -->
    @if (data.driver === 'DRIVER_PATIENT') {
      <aux-forecast-table-grid-period-patient
        [tooltip]="
          componentParent.checkService.tooltipText(
            componentParent.isForecastFinalized || componentParent.isClosedMonthsProcessing,
            componentParent.userHasModifyPermissions
          )
        "
        [periodPatientOptions]="componentParent.periodService.PeriodPatientOptions"
        [selectedPeriodPatientOption]="'Patient Curve'"
      />
    }

    <!-- Period if driver=time (activity) -->
    @if (data.driver === 'DRIVER_TIME') {
      <aux-forecast-table-grid-period-time
        [placeholder]="componentParent.checkService.formControlConstants.PLACEHOLDER.SELECT"
        [isChild]="true"
        [onPeriodChange]="componentParent.onPeriodChange"
        [categoryId]="data.id"
        [primarySettingsId]="data.primarySettingsId"
        [disabled]="
          (data.parentCategory?.primarySettingsOverride && !data.primarySettingsOverride) ||
          componentParent.isForecastFinalized ||
          componentParent.isClosedMonthsProcessing ||
          disablePeriod
        "
        [tooltip]="
          componentParent.checkService.tooltipText(
            componentParent.isForecastFinalized || componentParent.isClosedMonthsProcessing,
            componentParent.userHasModifyPermissions
          )
        "
        [isInvalid]="
          (componentParent.checkService.isShowError(data.primarySettingsId) | async) ||
          (componentParent.checkService.isActivityUnforecasted(data.id) | async) ||
          false
        "
        [fullSettings]="data.fullActivity!.primary_settings"
        [timelinePhases]="componentParent.timelinePhases"
        [PeriodService]="componentParent.periodService"
      />
    }

    <!-- Period if driver=custom curve -->
    @if (data.driver === 'DRIVER_CUSTOM') {
      <aux-forecast-table-grid-period-custom-curve
        [tooltip]="
          componentParent.checkService.tooltipText(
            componentParent.isForecastFinalized || componentParent.isClosedMonthsProcessing,
            componentParent.userHasModifyPermissions
          )
        "
      />
    }
  </div>
}
